import React, { ReactNode, useState } from "react";

import {
  Box,
  Card,
  Collapse,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";

import RemoveIcon from "@mui/icons-material/Remove";

import AddIcon from "@mui/icons-material/Add";

type Props = {
  title: string;
  defaultExpanded?: boolean;
  preview?: string;
  children: ReactNode;
};

export function CollapsibleSectionCard({
  title,
  defaultExpanded = true,
  preview,
  children,
}: Props) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 2,
        borderColor: "divider",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          px: 2.5,
          py: 1.75,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        <Stack spacing={0.25} sx={{ minWidth: 0 }}>
          <Typography variant="h6" fontWeight={600}>
            {title}
          </Typography>

          {!expanded && preview ? (
            <Typography variant="body2" color="text.secondary" noWrap>
              {preview}
            </Typography>
          ) : null}
        </Stack>

        <IconButton
          aria-label={expanded ? "Recolher" : "Expandir"}
          onClick={() => setExpanded((v) => !v)}
          size="small"
          sx={{ color: "text.secondary" }}
        >
          {expanded ? <RemoveIcon /> : <AddIcon />}
        </IconButton>
      </Box>

      <Collapse in={expanded} unmountOnExit>
        <Box sx={{ px: 2.5, pb: 2.5, pt: 0.5 }}>{children}</Box>
      </Collapse>
    </Card>
  );
}
